import { unreadCount, tipuri } from '@/modules/noutati/index.js';
const STORAGE_LAST_ACCESSED = 'noutati.lastAccessed';
const STORAGE_READ = 'noutati.read';

const getRead = k => {
  const item = localStorage.getItem(k);
  const def = [];
  if (item === null) {
    return def;
  }

  try {
    const data = JSON.parse(item);

    return typeof data === typeof def ? data : def;
  } catch (e) {
    return def;
  }
};

const getLastAccessed = k => {
  const item = localStorage.getItem(k);
  const def = 0;
  let data = {};
  try {
    data = JSON.parse(item) || {};
  } catch (e) {}

  return tipuri.reduce((carry, key) => ({...carry, [key]: data[key] || def }), {})
};

export default {
  namespaced: true,
  state: {
    read: getRead(STORAGE_READ),
    unreadCountLoaded: false,
    unreadCountLoading: false,
    unreadCount: tipuri.reduce((carry, key) => ({...carry, [key]: 0 }), {}),
    lastAccessed: getLastAccessed(STORAGE_LAST_ACCESSED)
  },
  mutations: {
    markAsRead(state, id) {
      if (state.read.includes(id) === false) {
        state.read.push(id);
      }
    },
    updateLastAccessed(state, { what, when }) {
      state.lastAccessed[what] = when;
      state.unreadCount[what] = 0;
    },
    updateUnreadCount(state, count) {
      tipuri.forEach(what => {
        state.unreadCount[what] = count[what];
      });

      state.unreadCountLoaded = true;
    }
  },
  actions: {
    markAsRead({ commit, state }, id) {
      commit('markAsRead', id);
      localStorage.setItem(STORAGE_READ, JSON.stringify(state.read));
    },
    updateUnreadCount: ({ state, commit, rootState }) =>
      state.unreadCountLoaded
        ? Promise.resolve()
        : unreadCount(rootState.lang.lang, state.lastAccessed)
          .then(response => response.json()
            .then(payload => {
              if (response.ok) {
                commit('updateUnreadCount', payload.data);
              }
            })),
    updateLastAccessed: ({ commit, state }, what) => {
      commit('updateLastAccessed', { what, when: parseInt(new Date().getTime() / 1000) });
      localStorage.setItem(STORAGE_LAST_ACCESSED, JSON.stringify(state.lastAccessed));
    }
  }
};
